<template>
  <nav class="nav">
    <div class="mobile">
      <a :href="this.loggedIn ? '/vff' : '/'">
        <img
          class="logo"
          :src="require('@/assets/images/logo-vff.png')"
          alt=""
        />
      </a>
      <button
        class="toggle-links hide-for-medium"
        @click="showLinks = !showLinks"
      >
        <span class="toggle-links-text">{{
          showLinks ? "close" : "menu"
        }}</span>
        <div
          class="hamburger hamburger--spring"
          :class="{ 'is-active': showLinks }"
        >
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </div>
      </button>
    </div>
    <div class="links-container">
      <div class="links" :class="{ '-active': showLinks }">
        <div class="links-inner">
          <v-link
            v-for="link in links"
            :key="link.name"
            class="link"
            :to="link.path ? { path: link.path } : { name: link.name }"
            @click.native="hideLinks"
            >{{ link.label }}</v-link
          >
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import VLink from "@/components/Link.vue";
import auth from "@/auth";

export default {
  components: {
    VLink,
  },
  data() {
    let links = [];
    if (auth.loggedIn()) {
      links = [
        {
          name: "standards",
          label: "Standards & resources",
        },
        {
          name: "vff-framework-description",
          label: "About the VFF",
        },
        {
          name: "process-flowchart",
          label: "Process",
        },
        {
          name: "resources",
          label: "Application pack",
        },
        {
          name: "weekly-updates",
          label: "News",
        },
        {
          name: "useful-resources",
          label: "Care home list",
        },
        {
          name: "logout",
          label: "Logout",
        },
      ];
    } else {
      links = [
      {
          name: "vff-framework-description",
          label: "About the VFF",
        },
        {
          name: "weekly-updates",
          label: "News",
        },
        {
          name: "useful-resources",
          label: "Care home list",
        },
        {
          path: "vff/contact-us",
          label: "Register",
        },
        {
          name: "login",
          label: "Login",
        },
      ];
    }

    return {
      showLinks: false,
      links,
    };
  },
  computed: {
    loggedIn() {
      return auth.loggedIn();
    },
  },
  methods: {
    hideLinks() {
      this.showLinks = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "foundation-sites/scss/foundation.scss";
@import "@/assets/scss/_settings";
@import "hamburgers/_sass/hamburgers/hamburgers.scss";
.nav {
  background-color: #fff;
  border-bottom: 1px solid #c7c7c7;
  position: relative;
  z-index: map-get($z-indexes, "nav");
  @include breakpoint(medium) {
    padding: 8px vw-relative(20);
    display: flex;
    justify-content: space-between;
  }
}
.mobile {
  @include breakpoint(small only) {
    padding: 16px vw-relative(46);
    display: flex;
    background-color: #fff;
    justify-content: space-between;
  }
}
.logo {
  width: 120px;
  width: clamp(120px, 152px);
}
.back {
  font: 600 13px/1 CenturyGothic;
  @include clamp-font(10px, 13px);
  text-transform: uppercase;
  text-decoration: none;
  color: #00205b;
  padding: 1em 0 0;
  display: inline-block;
}
.links-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
}
.links {
  @include breakpoint(small only) {
    transform: translateY(-100%);
    position: absolute;
    align-items: center;
    top: 100%;
    left: 0;
    z-index: -1;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    background-color: #fff;
    transition: transform 0.5s;
    overflow: auto;
    &.-active {
      transform: translateY(1px);
    }
  }
  &-inner {
    align-items: center;
    display: flex;
    @include breakpoint(small only) {
      flex-wrap: wrap;
      order: 1;
      width: 100%;
    }
  }
}
.icon-link {
  width: 20px;
  width: clamp(20px, 30px);
  height: 20px;
  height: clamp(20px, 30px);
  background-repeat: no-repeat;
  background-size: 80% 80%;
  background-position: center;
  display: inline-block;
  @include breakpoint(small only) {
    width: 50%;
    padding: vw-relative(20, 320);
    background-size: auto 50%;
    border-bottom: 1px solid #c7c7c7;
    order: 2;
    &:first-of-type {
      border-right: 1px solid #c7c7c7;
    }
  }
  &.-home {
    background-image: url("~@/assets/images/home.svg");
  }
  &.-profile {
    background-image: url("~@/assets/images/profile.svg");
  }
}
.link {
  margin: 0 1em;
  display: inline-block;
  padding: 1em 0 0.8em;
  font: 600 16px/1 CenturyGothic;
  @include clamp-font(12px, 16px);
  color: #6c2477;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  @include breakpoint(small only) {
    width: 100%;
    border-bottom: 1px solid #c7c7c7;
    margin: 0;
    padding: vw-relative(20, 320);
    order: 1;
  }
  @include breakpoint(large) {
    margin: 0 1.6em;
  }
}
.book {
  @include breakpoint(small only) {
    width: 100%;
    position: relative;
    z-index: 1;
  }
}
.toggle-links {
  font: 600 16px/1 CenturyGothic;
  text-transform: uppercase;
  color: #6b2377;
  display: flex;
  align-items: center;
}
.toggle-links-text {
  margin-right: 0.4em;
}
</style>
